// pages/settings/index.tsx
import { useEffect, useState } from "react";
import Tabs from "./Tabs";
import Organization from "./Organization";
import Users from "./Users";
import Groups from "./Groups";
import SidebarResponsiveComp from "../../components/sideBar/siderbar-responsive";
import HeaderManager from "../../components/headerManager";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/Toast";
import { useNavigate } from "react-router-dom";
import { UserRole } from "../../enums/user";
import { useTranslation } from 'react-i18next';

export default function SettingsPage() {
  const { t } = useTranslation('settings');
  const { user } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.user?.role && Number(user.user.role) === UserRole.group_responsible) {
      showToast(t('organization.adminOnlyMessage'), 'error', 15000);
      navigate('/admin', { replace: true });
    }
  }, [user, navigate, showToast, t]);
  
  const [selectedTab, setSelectedTab] = useState("organization");

  const renderTab = () => {
    switch (selectedTab) {
      case "organization":
        return <Organization />;
      case "users":
        return <Users />;
      case "groups":
        return <Groups />;
      default:
        return null;
    }
  };

  return (
    <div className="p-6">

      <SidebarResponsiveComp title={t('page.title')} />
      <HeaderManager title={t('page.title')} />


      <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <div className="mt-4">{renderTab()}</div>
    </div>
  );
}
